import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";

export function usePreview(api, tid, layout, copy) {
  const [url, setUrl] = useState(null);
  const [busy, setBusy] = useState(false);
  const timer = useRef(null);
  useEffect(() => {
    if (!layout) return undefined;
    clearTimeout(timer.current);
    timer.current = setTimeout(async () => {
      setBusy(true);
      try {
        const r = await api.post(`/artifacts/${tid}/preview`, copy ? { ...layout, copy } : layout, { responseType: "blob" });
        setUrl((old) => { if (old) URL.revokeObjectURL(old); return URL.createObjectURL(r.data); });
      } catch (e) { toast.error("Preview failed"); } finally { setBusy(false); }
    }, 600);
    return () => clearTimeout(timer.current);
  }, [api, tid, layout, copy]);
  return { url, busy };
}
